module.exports = __webpack_public_path__ + "static/img/20221224_02.dc36552.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/20221224_02.png
// module id = VW0z
// module chunks = 0